import Results from "../Results/Results";
import "./Discover.css";

const Discover = () => (
  <main className="discover-page">
    <header className="discover-page__header">
      <p>DISCOVER</p>
      <h1>Find your next watch.</h1>
      <span>Search for something specific, or build a recommendation around your mood and the services you have.</span>
    </header>
    <Results />
  </main>
);

export default Discover;
